/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { WindSpeedUnitsEnum } from "./WindSpeedUnitsEnum";
import {
  WindSpeedUnitsEnumFromJSON,
  WindSpeedUnitsEnumFromJSONTyped,
  WindSpeedUnitsEnumToJSON,
  WindSpeedUnitsEnumToJSONTyped,
} from "./WindSpeedUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface TimeseriesWind
 */
export interface TimeseriesWind {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * [time, speed, direction]
   */
  values?: Array<Array<number>>;
  /**
   * wind speed unit (default 'm/s')
   *
   * * `m/s` - meter_per_second
   * * `km/h` - kilometer_per_hour
   */
  units?: WindSpeedUnitsEnum;
  /**
   * interpolate wind speed
   */
  speedInterpolate?: boolean;
  /**
   * constant wind speed
   */
  readonly speedConstant?: boolean;
  /**
   * interpolate wind direction
   */
  directionInterpolate?: boolean;
  /**
   * constant wind direction
   */
  readonly directionConstant?: boolean;
}

/**
 * Check if a given object implements the TimeseriesWind interface.
 */
export function instanceOfTimeseriesWind(value: object): value is TimeseriesWind {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  return true;
}

export function TimeseriesWindFromJSON(json: any): TimeseriesWind {
  return TimeseriesWindFromJSONTyped(json, false);
}

export function TimeseriesWindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesWind {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    values: json["values"] == null ? undefined : json["values"],
    units: json["units"] == null ? undefined : WindSpeedUnitsEnumFromJSON(json["units"]),
    speedInterpolate: json["speed_interpolate"] == null ? undefined : json["speed_interpolate"],
    speedConstant: json["speed_constant"] == null ? undefined : json["speed_constant"],
    directionInterpolate:
      json["direction_interpolate"] == null ? undefined : json["direction_interpolate"],
    directionConstant: json["direction_constant"] == null ? undefined : json["direction_constant"],
  };
}

export function TimeseriesWindToJSON(json: any): TimeseriesWind {
  return TimeseriesWindToJSONTyped(json, false);
}

export function TimeseriesWindToJSONTyped(
  value?: Omit<
    TimeseriesWind,
    "id" | "uid" | "url" | "simulation" | "speedConstant" | "directionConstant"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    values: value["values"],
    units: WindSpeedUnitsEnumToJSON(value["units"]),
    speed_interpolate: value["speedInterpolate"],
    direction_interpolate: value["directionInterpolate"],
  };
}
